import { useState, ReactNode, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// pages
import Login from '../pages/authentication/Login';
import { useSelector, RootState } from '../redux/store';

// ----------------------------------------------------------------------

type AuthGuardProps = {
  children: ReactNode;
};

export default function EndUserAuthGuard({ children }: AuthGuardProps) {
  const { user } = useSelector((state: RootState) => state.user);
  const { isAuthenticated } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(null);

  const [userEmailInUrl, setUserEmailInUrl] = useState<string | undefined>(undefined);

  let navigate = useNavigate();

  useEffect(() => {
    const urlSearchParams: any = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.hasOwnProperty('user')) {
      setUserEmailInUrl(window.atob(params.user));
      urlSearchParams.delete('user');
      let forwardURl = window.location.pathname;
      if (urlSearchParams.toString().length > 0) {
        forwardURl = `${window.location.pathname}?${urlSearchParams.toString()}`;
      }
      window.history.pushState({}, document.title, forwardURl);
    }
  }, []);

  let userClean: Object | null = null;
  if (!user) {
    const userJSON = window.localStorage.getItem('user');
    if (userJSON) {
      userClean = JSON.parse(userJSON);
    }
  }
  if (!userClean) {
    if (!user) {
      return <Login userEmail={userEmailInUrl} />;
    } else if (!user.attributes.roles.includes('ROLE_END_USER')) {
      if (user.attributes.roles.includes('ROLE_USER')) {
        if (isAuthenticated) navigate(`/`);
      }
      return <Login userEmail={userEmailInUrl} />;
    }
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login userEmail={userEmailInUrl} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
